import { render, staticRenderFns } from "./Keyborad-Inscript-Hindi.vue?vue&type=template&id=2025ab62&"
import script from "./Keyborad-Inscript-Hindi.vue?vue&type=script&lang=js&"
export * from "./Keyborad-Inscript-Hindi.vue?vue&type=script&lang=js&"
import style0 from "./Keyborad-Inscript-Hindi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports